import { useApiQuery } from '@/hooks/useApiQuery';
import { apiGet, operationsClient } from '@/lib/api/client';
import { taxZoneEndpoints } from '@/lib/api/endpoints';
import { taxZoneKeys } from '@/lib/queryKeys';
import type { TaxZoneSummary } from '@/types/tax';

export function useTaxZoneSummary() {
  return useApiQuery<TaxZoneSummary>({
    queryKey: taxZoneKeys.summary(),
    queryFn: () => apiGet<TaxZoneSummary>(operationsClient, taxZoneEndpoints.summary()),
    showErrorToast: false,
  });
}
